import { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import EastIcon from '@mui/icons-material/East';

import CustomButton from "./common/customButton";
import CustomModal from "./common/customModal";

const BannerComponent = () => {
    const [showAlertModal, setShowAlertModal] = useState(false);

    const styles = {
        mainContainer: {
            minHeight: '800px',
        },
        leftContainer: {
            backgroundColor: '#EDEDED'
        },
        rightContainer: {
            backgroundColor: '#19A7CE'
        },
        mainTitle: {
            color: 'var(--Text-Gray-900, #18191F)',
            fontFamily: "Noticia Text",
            fontSize: '72px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '63px',
            letterSpacing: '0.72px',
            width: '70%'
        },
        contentContainer:{
            marginLeft: '15%',
            marginTop: '25%',
            flexDirection: 'column'
        },
        descText: {
            width: '70%',
            fontSize: '18px',
            marginTop: '2.5%',
            textAlign: 'justify'
        },
        button: {
            borderRadius: '6px',
            marginRight: '75px', 
            width: '160px',
            height: '50px',
            marginTop: '2.5%'
        },
        containerImage: {
            width: '150px',
            height: '150px',
            borderRadius: '75px'
        },
        containerLargerImage: {
            width: '170px',
            height: '170px',
            borderRadius: '85px'
        },
        containerLargestImage: {
            width: '190px',
            height: '190px',
            borderRadius: '95px',
            overflow: 'hidden'
        },
        dottedSquare: {
            width: '50px',
            height: '50px'
        }
    }

    const openAlertModal = () => {
        setShowAlertModal(true);
    };

    const closeAlertModal = () => {
        setShowAlertModal(false);
    };

    return (
        <Box>
            <Grid container sx={styles.mainContainer}>
                <Grid item sm={7} md={7} lg={7} xl={7} sx={styles.leftContainer}>
                    <Grid container sx={styles.contentContainer}>
                        <Typography variant="body1" sx={styles.mainTitle}>Empowering careers, forging connections</Typography>
                        <Typography variant="body1" sx={styles.descText}>Embark on the Next Era of Professional Networking with ConectYu. Advance Your Journey Today!</Typography>
                        <CustomButton 
                            varaint="filled"
                            bgColor="#1E4276"
                            textColor="white"
                            style={styles.button}
                            onHoverColor="white"
                            onHoverbgColor="#58758C"
                            onClick={openAlertModal}
                        >Get Started &nbsp;&nbsp;<EastIcon /></CustomButton>
                    </Grid>
                </Grid>
                <Grid item sm={5} md={5} lg={5} xl={5} sx={{ ...styles.rightContainer, position: 'relative' }}>
                    <img alt="pic" src="./assets/halfCircletHorizontal.svg" style={{ position: 'absolute', top: '10%', left: '-6%' }} />
                    <img alt="pic" src="./assets/suitpic.jpg" style={{ ...styles.containerImage, position: 'absolute', top: '27.5%', left: '-75px' }}/>
                    <div style={{ ...styles.containerLargestImage, position: 'absolute', top: '19%', left: '41%', zIndex: 1 }} ><img alt="pic" src="./assets/graduateGirlpic.jpg" width='200px' height='280px' /></div>
                    <img alt="pic" src="./assets/dottedSquare.svg" style={{ ...styles.dottedSquare, position: 'absolute', top: '20%', left: '67.5%', zIndex: 0 }} />
                    <img alt="pic" src="./assets/halfCircle.svg" style={{ position: 'absolute', top: '40%', right: 0, transform: 'rotate(-90deg)' }} />
                    <img alt="pic" src="./assets/keyboardpic.jpg" style={{ ...styles.containerImage, position: 'absolute', top: '58%', left: '16%', zIndex: 1 }} />
                    <img alt="pic" src="./assets/dashedCircle.svg" style={{ ...styles.containerImage, position: 'absolute', top: '60.5%', left: '26%', zIndex: 0}} />
                    <img alt="pic" src="./assets/grouppic.jpg" style={{ ...styles.containerLargerImage, position: 'absolute', top: '66.5%', left: '60%', zIndex: 1 }} />
                    <img alt="pic" src="./assets/dottedSquare.svg" style={{ ...styles.dottedSquare, position: 'absolute', top: '67.5%', left: '84%', zIndex: 0 }} />
                    <img alt="pic" src="./assets/halfCircle.svg" style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)' }} />
                </Grid>
            </Grid>

            {
                showAlertModal 
                ? (
                    <CustomModal 
                        title="Hang tight!" 
                        desc="We are working on this feature to make it available!"
                        style={{
                            backgroundColor: 'white', 
                            width: '40%', 
                            marginLeft: '30%', 
                            marginTop: '10%',
                            padding: '25px',
                            borderRadius: '25px'
                        }} 
                        setOnClose={closeAlertModal} 
                        imageUri="./assets/hangon.gif"
                    />
                )
                : null
            }
        </Box>
    )
};

export default BannerComponent;